import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCharge,
  UpdateCharge,
} from "../../../store/charge-store/charge-actions";
import ChargeForms from "../../../components/Forms/ChargeForms";
import { getTokenInfo } from "../../../utils/Guard";

const ChargeEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const charge = useSelector((state) => state.charge.charge);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (charge.id===undefined || charge.id === 0) {
      dispatch(GetCharge(param.chargeId, userInfo.Email));
    }
  }, [param.chargeId, userInfo.Email, dispatch, charge]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <ChargeForms actionCharge={UpdateCharge} charge={charge} />
    </div>
    </>
  );
};
export default ChargeEdit;
